import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { inputStyles } from "../styles";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    inputBase: {
      background: theme.white50,
    },
    input: {
      width: "100%",
      ...inputStyles,
    },
    helperText: {
      background: "transparent",
    },
    wrapper: {
      width: 320,
      background: theme.white50,
      borderRadius: "8px",
      boxShadow: `0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)`,
    },
    calendar: {
      padding: theme.spacing(12, 12, 4, 12),
    },
    btnWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      borderTop: `1px solid ${theme.gray200}`,
      padding: theme.spacing(4),
    },
    day: {
      width: 36,
      height: 36,
      minWidth: 36,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 14,
      borderRadius: "8px",
      cursor: "pointer",
      userSelect: "none",
    },
    daySelected: {
      backgroundColor: theme.primary500,
      color: theme.white00,
    },
    daysWrapper: {
      display: "flex",
      flexWrap: "wrap",
      padding: theme.spacing(5),
    },
    settingsWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    chevrons: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(10),
      "& svg": {
        cursor: "pointer",
      },
    },
  }),
);
